<div class="asset-container" *ngIf="markdown.trim().length">

  <h4 class=" pt-5 pb-3  font-weight-bold d-block">
    {{ title | assetDetailFormatHeader }}
  </h4>

  <div Markdown [data]="markdown"></div>

  <ng-content></ng-content>
</div>

